
namespace TabAurous.Scheme {

    @Serenity.Decorators.registerClass()
    export class SchemePaymentDetailsGrid extends Serenity.EntityGrid<SchemePaymentDetailsRow, any> {
        protected getColumnsKey() { return 'Scheme.SchemePaymentDetails'; }
        protected getDialogType() { return SchemePaymentDetailsDialog; }
        protected getIdProperty() { return SchemePaymentDetailsRow.idProperty; }
        protected getInsertPermission() { return SchemePaymentDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return SchemePaymentDetailsRow.localTextPrefix; }
        protected getService() { return SchemePaymentDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}